module.exports = __webpack_public_path__ + "ipetbooking/admin/img/ga_3.d945c06f.jpg";